import React, { FC } from 'react';
import {
    Avatar,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Text,
    Tooltip,
} from '@maas-components/core';
import clsx from 'clsx';
import { Check } from '@maas-components/icons';
import useStyles from '../styles';
import { Seller } from '../../types';

export type SellerInfoProps = {
    seller: Seller;
    currentSeller: Seller;
    mode: 'dark' | 'light';
};

const SellerInfo: FC<SellerInfoProps> = ({ mode, seller, currentSeller }) => {
    const classes = useStyles({ mode });
    const isSelected = currentSeller && currentSeller.tenantId === seller.tenantId;
    const avatarClassName = clsx({
        [classes.sellerAvatar]: !isSelected,
        [classes.selectedSellerAvatar]: isSelected,
    });

    const listItemClass = clsx(classes.listItem, {
        [classes.selectedListItem]: isSelected,
    });

    const handleChangeSeller = (tenantId: string) => {
        if (tenantId !== currentSeller.tenantId) {
            sessionStorage.setItem('maas-tenantId', tenantId);
            window.location.href = window.location.href.replace(/tenantId=(?:\w*)/, '');
        }
    };

    return (
        <>
            <ListItem
                button
                key={seller.tenantId}
                alignItems="flex-start"
                onClick={() => handleChangeSeller(seller.tenantId)}
                className={listItemClass}
            >
                <ListItemAvatar>
                    <Avatar className={avatarClassName} alt={seller.legalName}>
                        {seller?.legalName && seller.legalName.substring(0, 1).toUpperCase()}
                    </Avatar>
                </ListItemAvatar>
                <ListItemText
                    primary={
                        <React.Fragment>
                            <Text
                                className={classes.listItemTitle}
                                component="span"
                                fontSize="small"
                                color="textPrimary"
                                fontWeight="medium"
                            >
                                {seller.legalName}
                            </Text>
                        </React.Fragment>
                    }
                    secondary={
                        <Text component="span" fontSize="small" color="textSecondary">
                            {`@${seller.tenantId}`}
                        </Text>
                    }
                />
                {currentSeller && currentSeller.tenantId === seller.tenantId && (
                    <ListItemSecondaryAction>
                        <Tooltip title="Organização Selecionada">
                            <Check className={classes.selectedIcon} />
                        </Tooltip>
                    </ListItemSecondaryAction>
                )}
            </ListItem>
        </>
    );
};

export default SellerInfo;
